import React from 'react';
import PropTypes from 'prop-types';

export default function PrintStack({ thumbnail }) {
  return (
    <div className="prints-stack" data-test-id="prints-stack-image">
      <div />
      <div />
      <div />
      <img src={thumbnail} className="img-fluid" />
    </div>
  );
}

PrintStack.propTypes = {
  thumbnail: PropTypes.string.isRequired,
};
